import { Stack, Typography, Box, Button, alpha, Divider, Container } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';

import { Icon } from '@iconify/react';

const ContentOverlay = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  backgroundImage: `url(/assets/background/apizf_logo_icon.png)`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
}));

export default function HomeNewsletter() {
  return (
    <ContentOverlay>
      <Stack position="relative" py={10} bgcolor={(t) => alpha(t.palette.error.main, 0.9)}>
        <Container>
          <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
            <Stack width={1}>
              <NewLetterCard
                title="Infolettre"
                icon="mdi:email-newsletter"
                desc="Abonnez-vous pour recevoir les dernières nouvelles sur les sujets économiques qui comptent pour la métropole"
                actiontitle="Je m'abonne"
              />
            </Stack>
            <Stack>
              <Divider orientation="vertical" sx={{ bgcolor: '#FFF', width: 3 }} />
            </Stack>
            <Stack width={1}>
              <NewLetterCard
                title="Pourquoi choisir le Togo"
                icon="ion:document-text-outline"
                desc="Découvrez tous les avantages du Togo pour votre entreprise"
                actiontitle="Télécharger le PDF"
              />
            </Stack>
          </Stack>
        </Container>
      </Stack>
    </ContentOverlay>
  );
}

const NewLetterCard = ({ icon, title, desc, actiontitle }) => (
  <Stack width={1} direction="row" px={{ xs: 2, md: 5 }} spacing={2}>
    <Stack>
      <Box py={1} px={1.5} borderRadius={10} border="1px solid #FFF">
        <Icon icon={icon} color="#FFF" height={70} width={70} />
      </Box>
    </Stack>
    <Stack spacing={2}>
      <Typography variant="h2" color="common.white">
        {title}
      </Typography>
      <Typography variant="h5" color="common.white" fontWeight="500">
        {desc}
      </Typography>
      <Stack direction="row">
        <Button
          sx={{
            color: 'black',
            bgcolor: '#FFF',
            p: 1,
            fontSize: 18,
            borderRadius: 4,
            ':hover': { bgcolor: '#FFF', color: 'black' },
          }}
          endIcon={<Icon icon="ic:round-keyboard-arrow-right" />}
        >
          {actiontitle}
        </Button>
      </Stack>
    </Stack>
  </Stack>
);
